import { GroupBox } from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { useStackStyles } from './styles';
import { ErrorStackProps } from './types';

const ErrorStack = ({ stack }: ErrorStackProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const classes = useStackStyles();

  return (
    <GroupBox
      collapsible
      defaultCollapsed
      label={formatMessage(messages.stack)}
    >
      <GroupBox.Content className={classes.container}>
        <pre className={classes.code}>{stack}</pre>
      </GroupBox.Content>
    </GroupBox>
  );
};

export default memo(ErrorStack);
